import { axiosInstanceV1, useAuthQuery } from "@bn/api";
import { LOAD_MARKET_CAP_BY_ISIN } from "@api/cacheKeys";
import type { MarketCapitalization } from "@bn/api/apiv1";

interface Params {
  isin: string;
  quoteProvider: string;
  tickerSymbol: string;
  convertToCurrency: string;
}

// Same doubled-path problem as `useFundamental` — see the note there.
const loadMarketCap = async (
  token: string | undefined,
  { isin, ...params }: Params
) => {
  const { data } = await axiosInstanceV1.get<MarketCapitalization>(
    `/fundamentals/${isin}/marketCapitalization`,
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const useMarketCap = (
  isin?: string,
  quoteProvider?: string,
  tickerSymbol?: string,
  currency?: string
) =>
  useAuthQuery(
    [LOAD_MARKET_CAP_BY_ISIN, isin, quoteProvider, tickerSymbol, currency],
    ({ token }) =>
      loadMarketCap(token, {
        isin: isin!,
        quoteProvider: quoteProvider!,
        tickerSymbol: tickerSymbol!,
        convertToCurrency: currency!,
      }),
    {
      enabled: !!isin && !!quoteProvider && !!tickerSymbol && !!currency,
    }
  );
